import { createAction, handleActions } from 'redux-actions';
// api
import api from '../../utils/api';
// utils
import {
  prepareTriggersData,
  prepareDataList,
} from '../../containers/RecoveryPlan/utils';

const initialState = {
  isLoading: false,
  isLoaded: false,
  isRecoveryUpdating: false,
  shouldBeUpdated: true,
  riskQuestions: [],
  satisfactionQuestions: [],
  dailyCheck: [],
};

// const
export const GET_RECOVERY_PLAN = 'recovery/GET_RECOVERY_PLAN';
export const UPDATE_RECOVERY = 'recovery/UPDATE_RECOVERY';
export const SET_SHOULD_UPDATED = 'recovery/SET_SHOULD_UPDATED';
export const GET_SATISFACTION_QUESTIONS = 'recovery/GET_SATISFACTION_QUESTIONS';
export const SUBMIT_SATISFACTION = 'recovery/SUBMIT_SATISFACTION';
export const GET_RISK_QUESTIONS = 'recovery/GET_RISK_QUESTIONS';
export const SUBMIT_RISK = 'recovery/SUBMIT_RISK';
export const GET_DAILY_CHECK = 'recovery/GET_DAILY_CHECK';
export const GET_RECOVERY_STATS = 'recovery/GET_RECOVERY_STATS';
export const SUBMIT_DAILY_CHECK = 'recovery/SUBMIT_DAILY_CHECK';

// action creators
export const getRecoveryPlan = createAction(
  GET_RECOVERY_PLAN,
  api.recoveryPlan.getRecoveryPlan
);
export const updateRecoveryPlan = createAction(
  UPDATE_RECOVERY,
  api.recoveryPlan.updateRecoveryPlan
);
export const recoveryShouldBeUpdated = createAction(SET_SHOULD_UPDATED);
export const getSatisfactionQuestions = createAction(
  GET_SATISFACTION_QUESTIONS,
  api.recoveryPlan.getSatisfactionQuestions
);
export const submitSatisfaction = createAction(
  SUBMIT_SATISFACTION,
  api.recoveryPlan.submitSatisfaction
);
export const getRiskQuestions = createAction(
  GET_RISK_QUESTIONS,
  api.recoveryPlan.getRiskQuestions
);
export const submitRisk = createAction(SUBMIT_RISK, data => {
  return {
    promise: api.recoveryPlan.submitRisk(data),
    data,
  };
});
export const getDailyCheck = createAction(
  GET_DAILY_CHECK,
  api.recoveryPlan.getDailyCheck
);
export const getRecoveryStats = createAction(
  GET_RECOVERY_STATS,
  api.recoveryPlan.getRecoveryStats
);
export const submitDailyCheck = createAction(SUBMIT_DAILY_CHECK, data => {
  return {
    promise: api.recoveryPlan.submitDailyCheck(data),
    data,
  };
});

const updatePersonalList = (list = {}, resource = {}) =>
  list && list.id === resource.id ? resource : list;

const updateListBlock = (blockState, resource = {}) =>
  blockState
    ? {
        ...blockState,
        personal: updatePersonalList(blockState.personal, resource),
      }
    : blockState;

// reducer
const reducer = handleActions(
  {
    [`${GET_RECOVERY_PLAN}_REQUEST`]: state => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [`${GET_RECOVERY_PLAN}_SUCCESS`]: (state, { payload }) => {
      const {
        user_clock,
        my_goal,
        impact,
        my_trigger,
        my_breaker,
        my_motivator,
        satisfaction,
        relapse_risk,
        daily_check,
        stress_chart,
        chart_values,
        my_blocker,
      } = payload;
      const triggers = prepareTriggersData(my_trigger);
      const breakers = prepareDataList(my_breaker);
      const blockers = prepareDataList(my_blocker);
      const motivators = prepareDataList(my_motivator);

      return {
        ...state,
        triggers,
        breakers,
        blockers,
        motivators,
        satisfaction,
        isLoaded: true,
        isLoading: false,
        risk: relapse_risk,
        daily: daily_check,
        clock: user_clock,
        goals: my_goal,
        stress: stress_chart,
        valueChart: chart_values,
        impact,
        shouldBeUpdated: false,
      };
    },
    [`${UPDATE_RECOVERY}_REQUEST`]: state => {
      return {
        ...state,
        isRecoveryUpdating: true,
      };
    },
    [`${UPDATE_RECOVERY}_SUCCESS`]: (state, { payload: { resource = {} } }) => {
      return {
        ...state,
        blockers: updateListBlock(state.blockers, resource),
        breakers: updateListBlock(state.breakers, resource),
        motivators: updateListBlock(state.motivators, resource),
        goals: updatePersonalList(state.goals, resource),
        triggers: state.triggers
          ? {
              external: updateListBlock(state.triggers.external, resource),
              internal: updateListBlock(state.triggers.internal, resource),
            }
          : state.triggers,
        isRecoveryUpdating: false,
      };
    },
    [`${UPDATE_RECOVERY}_ERROR`]: state => {
      return {
        ...state,
        isRecoveryUpdating: false,
      };
    },

    [SET_SHOULD_UPDATED]: state => {
      return {
        ...state,
        shouldBeUpdated: true,
      };
    },
    [`${GET_SATISFACTION_QUESTIONS}_REQUEST`]: state => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [`${GET_SATISFACTION_QUESTIONS}_SUCCESS`]: (
      state,
      { payload: { resources, meta } }
    ) => {
      return {
        ...state,
        isLoading: false,
        satisfactionQuestions: {
          questions: resources,
          answers: meta.answers,
        },
      };
    },
    [`${GET_RISK_QUESTIONS}_REQUEST`]: state => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [`${GET_RISK_QUESTIONS}_SUCCESS`]: (state, { payload: { resources } }) => {
      return {
        ...state,
        isLoading: false,
        riskQuestions: resources,
      };
    },
    [`${SUBMIT_RISK}_REQUEST`]: (
      state,
      { payload: { shouldOpenRecovery } }
    ) => {
      return {
        ...state,
        shouldOpenRecovery,
      };
    },
    [`${GET_DAILY_CHECK}_REQUEST`]: state => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [`${GET_DAILY_CHECK}_SUCCESS`]: (state, { payload: { resource } }) => {
      return {
        ...state,
        isLoading: false,
        dailyQuestions: (resource && resource.questions) || [],
      };
    },
    [`${GET_RECOVERY_STATS}_REQUEST`]: state => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [`${GET_RECOVERY_STATS}_SUCCESS`]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        recoveryStats: payload,
      };
    },
    [`${SUBMIT_DAILY_CHECK}_REQUEST`]: (
      state,
      { payload: { shouldOpenRecovery } }
    ) => {
      return {
        ...state,
        shouldOpenRecovery,
      };
    },
  },
  initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/recovery.js